import { getPageTypes } from "@config/cms";
import { getSsrCmsPageProps } from "@utils/getSsrCmsPageProps";
import { getSsrCmsPagesProps } from "@utils/getSsrCmsPagesProps";
import { renderPage } from "@utils/renderPage";

const type = getPageTypes().promo;

export default function RegularPage(props) {
  return renderPage(props, type);
}

// export async function getStaticProps({ params, ...props }) {
//   try {
//     return getSsrCmsPageProps({ ...props, type, slug: params.slug });
//   } catch (error) {
//     console.log(error);
//     return {
//       redirect: {
//         destination: "/500",
//       },
//     };
//   }
// }

// export async function getStaticPaths({ locales }) {

//   let paths = [];

//   for (const locale of locales) {
//     const data = await getSsrCmsPagesProps({ locale, type })
//     const pages = data.getAllPagesUser.filter(page => !!page.data);

//     const localePaths = pages.map(page => ({
//       params: { slug: page.data.slug },
//       locale,
//     }));

//     paths = paths.concat(localePaths);
//   }

//   return { paths, fallback: 'blocking' };
// }


export const getServerSideProps = async ({ params, ...props }) => {
  return getSsrCmsPageProps({ ...props, type, slug: params.slug });
};